module.exports = "<div class=\"gw-row-layout\" gw-partial=\"Item\"></div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/platform/widgets/layouts/templates/Row.html
// module id = 584
// module chunks = 0